app.service('subscriptionWarranties', function (loading, modal, subscriptionResignForm) {

	let insuranceIdentifier;

	function init(props) {
		const {onPageChange} = props;

		setEvents(onPageChange);
	}

	function setEvents(onPageChange) {

		$('body')
			.on('click', '.js-subscription-warranties-page', function () {
				const pageNumber = $(this).data('page');
				onPageChange(pageNumber);
				$.scrollTo($('#subscription-payment-list'), 0);
			})
			.on('click', '.js-subscription-warranties-toggle', handleToggleClick)
			.on('click', '.js-subscription-payments-change-card', handleChangeCardClick)
			.on('click', '.js-subscription-warranties-resign', handleWarrantyResignClick)
			.on('click', '.js-subscription-warranties-confirm-resign', handleConfirmResignClick)
			.on('click', '.js-subscription-warranties-details', function () {
				showSubscriptionDetails($(this).data('recurring-payment-id'));
			})
			.on('click', '#modal-warranty-resign-modal .remodal-close', function() {
				sendUA("Przycisk X");
			})
			.on('click', '.js-cancel', function () {
				modal.close();
				sendUA("Przycisk Wróć");
			});

		$(document)
			.on('closed', '#modal-warranty-resign-modal', function (event, data) {
				if (data.reason && data.reason === 'outsideClick') {
					sendUA("Kliknięcie poza warstwę");
				}
			});
	}

	function sendUA(reason) {
		UA.push({
			event: "visitorInteraction",
			eventCategory: "InsuranceQuestionnaire",
			eventAction: "Zamknięcie popupa",
			eventLabel: reason
		});
	}

	function handleToggleClick() {
		$(this).closest('.additional-options').toggleClass('show-more').toggleClass('show-less');
	}

	function handleChangeCardClick() {
		const recurringPaymentId = $(this).closest('.subscription-item').data('id');
		loading.start();
		$.ajax({
			url: '/customer-subscription-payment-change-card.ltr',
			type: 'POST',
			data: {
				recurringPaymentId
			},
			success: function (result) {
				if (result.status === 'SUCCESS') {
					window.location = result.url;
				} else {
					loading.stop();
					modal.alert(result.messages[0]);
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później');
			}
		});
	}

	function showSubscriptionDetails(recurringPaymentId) {
		const $box = $(`.subscription-item[data-id="${recurringPaymentId}"]`);
		if (!$box.length) {
			return;
		}
		loading.start();
		$.ajax({
			url: '/customer-subscription-warranty-payment-list.ltr',
			data: {
				recurringPaymentId
			},
			success: (html) => {
				$('.subscription-item-details', $box).html(html);
				$.scrollTo($box);
			},
			error: () => {
				$('.subscription-item-details', $box).html('Wystąpił błąd komunikacji, prosimy spróbować później');
			},
			complete: () => {
				loading.stop();
			}
		});
	}

	function handleWarrantyResignClick() {
		insuranceIdentifier = $(this).data('id');
		modal.open('warranty-resign-modal');
	}

	function handleConfirmResignClick() {
		loading.start();

		const {closeReasonName, closeReasonDescription} = subscriptionResignForm.getResignFormData();

		$.ajax({
			url: '/customer-warranty-subscription-close.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				insuranceIdentifier,
				closeReasonName,
				closeReasonDescription
			}),
			success: function (result) {
				if (result.status === 'SUCCESS') {
					window.location.hash = 'ubezpieczenia';
					location.reload();
				} else {
					loading.stop();
					modal.alert(result.messages[0]);
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później');
			}
		});
	}

	/**
	 * Prezentacja zaległych płatności na stronie /konto.bhtml
	 */
	function checkForAccountOverdueSubscriptions() {
		const $accountOverdueSubscriptions = $('#overdue-warranties');
		const $accountMenu = $('#katalog-prod');
		if ($accountOverdueSubscriptions.length && $.trim($accountOverdueSubscriptions.html()).length === 0) {
			$.ajax({
				url: '/customerAccountOverdueSubscriptionWarranties.ltr',
				success: function (html) {
					if (html) {
						$accountOverdueSubscriptions.html(html);
						$accountMenu.addClass('overdue-payment-label');
					}
				}
			});
		}
	}

	return {
		init,
		showSubscriptionDetails,
		checkForAccountOverdueSubscriptions
	};
});